<template>
  <v-flex
    v-if="!loading"
    xs8
    offset-xs2
    align-self-center
    justify-center
  >
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs3 class="mr-2">
        <Search
          v-model="filters.search"
          :label="$t('SEARCH')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-spacer></v-spacer>
      <v-btn
        v-if="can('create schools_type')"
        @click="showSchoolTypeModal(0)"
        color="primary"
        dark
        class="mb-2"
      >{{ $t("NEW") }}
      </v-btn>
    </v-row>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.name="{ item }">
        <router-link :to="{ name: routeName.SCHOOL_TYPE_SHOW, params: { id: item.id } }">
            {{ item.name }}
        </router-link>
      </template>

      <template v-slot:item.updated_at="{ item }">
            {{ item.updated_at | timeFormat }}
      </template>
      <template v-slot:item.actions="{ item }">
            <v-layout row wrap>
              <v-flex class="text-no-wrap">
                <v-btn
                  icon
                  color="blue"
                  v-if="can('edit schools_type')"
                  @click="showSchoolTypeModal(item.id)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  v-if="can('delete schools_type')"
                  icon
                  color="red"
                  @click="deleteSchooltype(item.id)"
                >
                  <v-icon>cancel</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
      </template>
    </v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchSchoolsTypes"
    />
  </div>
  </v-flex>
  <Loader v-else/>
</template>
<script>
  import { mapActions } from 'vuex';

  import { schoolsTypesService } from '../../utils/services/schoolsTypes.service';
  import Search from '../../components/shared/Inputs/Search';
  import Loader from '../../components/shared/Loader';
  import SchoolTypeModal from '../../components/modals/SchoolsTypes/SchoolTypeModal';
  import Paginator from '../../components/shared/Paginator';

  export default {
    name: 'SchoolTypeList',
    components: { Search, Loader, Paginator },
    data() {
      return {
        loading: false,
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['name'],
        },
        headers: [
          {
            text: this.$t('fields.id'),
            align: 'left',
            value: 'id',
          },
          { text: this.$t('fields.name'), value: 'name' },
          { text: this.$t('fields.abbreviation'), value: 'code' },
          { text: this.$t('fields.grouped'), value: 'grouped' },
          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
        ],
        filters: {
          search: null,
        },
      };
    },
    computed: {
      requestFilters() {
        const filters = {
          search: this.filters.search,
        };
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),
      async fetchSchoolsTypes(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return schoolsTypesService.index({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      async showSchoolTypeModal(id) {
        this.showModal({
          component: SchoolTypeModal,
            data: {
              stored: {
                id,
              },
          },
          options: {
            title: this.$t('SCHOOL_TYPE'),
            onSave: (
              form,
              error,
            ) => schoolsTypesService.save(form)
            .then(() => {
              this.hideModal({});
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.fetchSchoolsTypes(this.pagination.page);
            }),
          },
        });
      },
      async deleteSchooltype(id) {
          this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return schoolsTypesService.remove(id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.fetchSchoolsTypes(this.pagination.page);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },
    },
    async created() {
      await this.fetchSchoolsTypes(this.pagination.page);
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchSchoolsTypes(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchSchoolsTypes(1);
          }
        },
      },

    },
  };
</script>
